export enum Currency {
  Yen = '¥',
}
